export default __webpack_public_path__ + "static/media/ic_charts.0c124a9a.svg";